import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import Loading from '../Loading/Loading';
import img from './../img/image-999.png';
import CheckboxMinus from './../../../copms/Checkbox/CheckboxMinus';
import CheckboxTick from './../../../copms/Checkbox/CheckboxTick';
import { request } from "./../../../config";
import YesNoModal from './../../../copms/Modal/YesNoModal';
import iconNotificationNot from '../img/notifications_not.svg';
import LinksModal from '../../../copms/Modal/LinksModal';
import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

class Notification extends Component {
    state = {
        selectedList: [],
        deleteOpen: false,
        notification: null,
        open: false,
        loading: false,
        dateRangeOpen: false,
        dateRangeFilter: 'none',
        beginDate: null,
        endDate: null,
    }

    capitalize = (s) => {
        if (typeof s !== 'string') return 'Az'
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    componentDidMount() {
        if (this.props.match.params.id && this.props.notifications.find(el => el.id == this.props.match.params.id) && this.props.notifications.find(el => el.id == this.props.match.params.id).isRead !== 1) {
            this.readIdFunc(this.props.match.params.id);
        }
        this.setState({ notification: this.props.notifications.find(el => el.id == this.props.match.params.id) })
    }

    formatDateYYYYMMDD = (date) => {
        if (!date) return null;
        if (date && typeof date.format === 'function') {
            return date.format('YYYY-MM-DD');
        }
        const pad = (value) => String(value).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    }

    getNotificationList = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let getNotificationListRequestBody = customerType === 'Juridical' ? {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            isWeb: true,
            beginDate: this.formatDateYYYYMMDD(this.state.beginDate),
            endDate: this.formatDateYYYYMMDD(this.state.endDate)
        } : {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            isWeb: true,
            beginDate: this.formatDateYYYYMMDD(this.state.beginDate),
            endDate: this.formatDateYYYYMMDD(this.state.endDate)
        };

        if (!this.state.beginDate) {
            delete getNotificationListRequestBody.beginDate;
        }
        if (!this.state.endDate) {
            delete getNotificationListRequestBody.endDate;
        }

        fetch(request("setting/getNotificationList", getNotificationListRequestBody))
            .then(res => res.text())
            .then((getNotificationListResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getNotificationListResponse = JSON.parse(getNotificationListResponseJSON);
                if (getNotificationListResponse.status.statusCode !== 1) {
                    if (getNotificationListResponse.status.statusCode === 200 || getNotificationListResponse.status.statusCode === 101) {
                        this.props.logout();
                    } else if (getNotificationListResponse.status.statusCode === 338) {
                        this.props.updateNotification([]);
                    }
                }
                else {
                    this.props.updateNotification(getNotificationListResponse.notificationList);
                    this.props.notificationCountRefresh();
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
            })
            .catch(() => {
                this.props.updateAppState('isLoadingTransparentBackground', false);
            });
    }

    openDateRange = () => {
        this.setState({ dateRangeOpen: !this.state.dateRangeOpen });
    }

    closeDateRange = () => {
        this.setState({ dateRangeOpen: false });
    }

    applyDateRange = () => {
        const { beginDate, endDate } = this.state;
        if (!beginDate || !endDate) return;
        this.setState({ dateRangeOpen: false }, () => {
            this.getNotificationList();
        });
    }

    clearDateRange = () => {
        this.setState({ dateRangeFilter: 'none', beginDate: null, endDate: null, dateRangeOpen: false }, () => {
            this.getNotificationList();
        });
    }

    setPresetRange = (range) => {
        const today = new Date();
        let beginDate = new Date(today);
        let endDate = new Date(today);

        if (range === 'thisWeek') {
            const dayIndex = today.getDay();
            const monday = new Date(today);
            monday.setDate(today.getDate() - ((dayIndex + 6) % 7));
            beginDate = monday;
        } else if (range === 'thisMonth') {
            beginDate = new Date(today.getFullYear(), today.getMonth(), 1);
        }

        this.setState({ beginDate, endDate, dateRangeFilter: range });
    }

    updateBeginDate = (beginDate) => {
        this.setState({ beginDate, dateRangeFilter: beginDate && this.state.endDate ? 'manual' : 'none' });
    }

    updateEndDate = (endDate) => {
        this.setState({ endDate, dateRangeFilter: this.state.beginDate && endDate ? 'manual' : 'none' });
    }

    selectFunc(type, index) {
        var nots = this.props.notifications;
        nots[index].isSelected = type;
        this.props.updateNotification(nots);
    }

    selectAllFunc(type) {
        var nots = this.props.notifications;
        this.props.updateNotification(nots.map((item, index) => {
            item.isSelected = type;
            return item;
        }));
    }

    deleteFunc() {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        var ids = this.props.notifications.filter(el => el.isSelected == true);
        let deleteRequestBody = customerType === 'Juridical' ? {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            custNotificationTokenId: ids.map((item) => (item.id)),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            custNotificationTokenId: ids.map((item) => (item.id)),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("setting/deleteNotification", deleteRequestBody))
            .then(res => res.text())
            .then((deleteRequestResponseJSON) => {
                const JSON = require('true-json-bigint');
                let deleteRequestResponse = JSON.parse(deleteRequestResponseJSON);
                if (deleteRequestResponse.status.statusCode !== 1) {

                }
                else {
                    var notifications = this.props.notifications;
                    ids.map((item) => notifications.splice(notifications.findIndex(el => el.id == item.id), 1));
                    this.props.updateNotification(notifications);
                    this.props.notificationCountRefresh();
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
            });
    }

    readSelectedFunc() {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        var ids = this.props.notifications.filter(el => el.isSelected == true);
        let readRequestBody = customerType === 'Juridical' ? {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            custNotificationTokenId: ids.map((item) => (item.id)),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            custNotificationTokenId: ids.map((item) => (item.id)),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("setting/readNotification", readRequestBody))
            .then(res => res.text())
            .then((readRequestResponseJSON) => {
                const JSON = require('true-json-bigint');
                let readRequestResponse = JSON.parse(readRequestResponseJSON);
                if (readRequestResponse.status.statusCode === 1) {
                    let notifications = this.props.notifications;
                    ids.map((item, index) => notifications.find(el => el.id == item.id).isRead = 1);
                    this.props.updateNotification(notifications);
                    this.props.notificationCountRefresh();
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
            });
    }

    readIdFunc(id) {
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let readRequestBody = customerType === 'Juridical' ? {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            custNotificationTokenId: [id],
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            custNotificationTokenId: [id],
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("setting/readNotification", readRequestBody))
            .then(res => res.text())
            .then((readRequestResponseJSON) => {
                const JSON = require('true-json-bigint');
                let readRequestResponse = JSON.parse(readRequestResponseJSON);
                if (readRequestResponse.status.statusCode === 1) {
                    let notifications = this.props.notifications;
                    notifications.find(el => el.id == id).isRead = 1;
                    this.props.updateNotification(notifications);
                    this.props.notificationCountRefresh();
                }
            });
    }

    componentDidUpdate(prevProps) {
        const { match, notifications } = this.props;
        const { id } = match.params;
        if (id !== prevProps.match.params.id || notifications !== prevProps.notifications) {
            const notification = notifications.find(el => el.id == id) || null;
            if (notification) {
                if (notification.isRead !== 1) {
                    this.readIdFunc(id);
                }
                this.setState({ notification }, () => {
                    if (id !== prevProps.match.params.id) {
                        this.getNotificationLinks(notification.notificationId);
                    }
                });
            } else {
                this.setState({ notification: null });
            }
        }
    }

    deleteConfirm(val) {
        if (val) {
            this.deleteFunc();
        }
    }

    getRedirectLink = (type, oprId) => {
        switch (type) {
            case 'ONLINE_ACCOUNT_OPENING':
                this.props.history.push('/dashboard/finance/accounts')
                break;
            case 'CREDIT_LOMBARD':
            case 'CREDIT_MKOS':
            case 'CREDIT_AKIA':
            case 'CREDIT_SIF':
            case 'CREDIT_ISTEHLAK':
                this.props.history.push('/dashboard/orders/credit', { oprId })
                break;
            case 'DEPOSIT_FURSET':
            case 'DEPOSIT_YIGIM':
            case 'DEPOSIT_SIRLER_XEZINESI':
                this.props.history.push('/dashboard/finance/deposits/order', { oprId })
                break;
            case 'ONLINE_CARD_DEBT':
            case 'ONLINE_CARD_KREDIT':
            case 'ONLINE_CARD_OTHER':
                this.props.history.push('/dashboard/orders/plastic-card', { oprId })
                break;
            case 'E_CONTRACT':
                this.props.history.push(`/dashboard/guarantees/create/${oprId}`)
                break;
            default:
                break;
        }
    }

    getNotificationLinks = (notificationId) => {
        this.setState({ loading: true });
        let getNotificationLinksRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            notificationId
        }
        fetch(request("setting/getNotificationLinks", getNotificationLinksRequestBody))
            .then(res => res.text())
            .then((getNotificationLinksResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getNotificationLinksResponse = JSON.parse(getNotificationLinksResponseJSON);
                if (getNotificationLinksResponse.status.statusCode !== 1) {
                    if (getNotificationLinksResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.setState({ loading: false });
                    }
                }
                else {
                    this.setState({ loading: false });
                }
                this.setState({ links: getNotificationLinksResponse.links ?? [] });
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    render() {
        let { deleteOpen, notification, open, links, loading, dateRangeOpen, dateRangeFilter, beginDate, endDate } = this.state;
        let { t, isLoading } = this.props;

        const selectedRangeLabel =
            dateRangeFilter === 'today' ? t('today') :
                dateRangeFilter === 'thisWeek' ? t('this week') :
                    dateRangeFilter === 'thisMonth' ? t('this month') :
                        dateRangeFilter === 'manual' ? `${t('From')} ${beginDate ? this.formatDateYYYYMMDD(beginDate) : '--'} ${t('to')} ${endDate ? this.formatDateYYYYMMDD(endDate) : '--'}` :
                            t('Date range');

        return (
            <Fragment>
                <style>{`
                    .date-picker-wrapper .MuiOutlinedInput-notchedOutline {
                        top: 0 !important;
                    }
                `}</style>
                <LinksModal onClose={() => this.setState({ open: false })} links={links} open={open} />
                <YesNoModal onClose={() => this.setState({ deleteOpen: false })} title={t('Are you sure you want to delete the notifications?')} open={deleteOpen} triggerFunc={val => this.deleteConfirm(val)} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('notifications')}</h2>
                    </div>
                    {/* <a href="http://turanbank.az/" className="dashboard-header-route-link">{t('ORDER A NEW CARD')}</a> */}
                </div>
                {/* <div className="dashboard-notification-filter-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, margin: '16px 0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                        <button type="button" onClick={this.openDateRange} style={{ background: '#0066B2', color: '#fff', border: 'none', borderRadius: 24, padding: '10px 16px', cursor: 'pointer' }}>
                            {t('select date range')}
                        </button>
                        {dateRangeFilter !== 'none' && (
                            <span style={{ color: '#586268', fontSize: 14 }}>
                                {selectedRangeLabel}
                            </span>
                        )}
                    </div>
                    {dateRangeFilter !== 'none' && (
                        <button type="button" onClick={this.clearDateRange} style={{ background: 'transparent', color: '#0066B2', border: '1px solid #0066B2', borderRadius: 24, padding: '10px 16px', cursor: 'pointer' }}>
                            {t('Clear')}
                        </button>
                    )}
                </div> */}
                <div className="dashboard-container-main-section">
                    <div className="dashboard-notification-section" style={{ width: '100%' }}>
                        <div className="dashboard-notification-section-left">
                            {/* <div className="dashboard-notification-section"> */}
                            <div className="dashboard-notification-section-header">
                                <div className="dashboard-notification-section-header-left">
                                    <CheckboxMinus
                                        onChecked={val => this.selectAllFunc(val)} />
                                    <span className="dashboard-notification-section-header-title">{t('CHOOSE ALL')}</span>
                                </div>
                                <div className="dashboard-notification-section-header-right">
                                    <button title={t("Mark as read")} className="dashboard-notification-section-header-button" style={{ padding: 5, cursor: this.props.notifications.filter(el => el.isSelected == true).length > 0 ? 'pointer' : 'auto', }} disabled={this.props.notifications.filter(el => el.isSelected == true).length > 0 ? false : true} onClick={() => this.readSelectedFunc()}>
                                        <svg width="18" height="18" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.6786 1.48936C11.8393 1.48936 12 1.35638 12 1.17021V0.319149C12 0.159574 11.8393 0 11.6786 0H0.321429C0.133929 0 0 0.159574 0 0.319149V1.17021C0 1.35638 0.133929 1.48936 0.321429 1.48936H11.6786ZM11.6786 5.74468C11.8393 5.74468 12 5.6117 12 5.42553V4.57447C12 4.41489 11.8393 4.25532 11.6786 4.25532H0.321429C0.133929 4.25532 0 4.41489 0 4.57447V5.42553C0 5.6117 0.133929 5.74468 0.321429 5.74468H11.6786ZM11.6786 10C11.8393 10 12 9.86702 12 9.68085V8.82979C12 8.67021 11.8393 8.51064 11.6786 8.51064H0.321429C0.133929 8.51064 0 8.67021 0 8.82979V9.68085C0 9.86702 0.133929 10 0.321429 10H11.6786Z"
                                                fill={this.props.notifications.filter(el => el.isSelected == true).length > 0 ? "#0066B2" : "#b7b7b7"} />
                                        </svg>
                                    </button>
                                    <button title={t("Delete selected ones")} className="dashboard-notification-section-header-button" style={{ padding: 5, cursor: this.props.notifications.filter(el => el.isSelected == true).length > 0 ? 'pointer' : 'auto', }} disabled={this.props.notifications.filter(el => el.isSelected == true).length > 0 ? false : true} onClick={() => this.setState({ deleteOpen: true })}>
                                        <svg width="18" height="18" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.92857 10.9688H8.35714C8.46429 10.9688 8.57143 10.8926 8.57143 10.7656V3.85938C8.57143 3.75781 8.46429 3.65625 8.35714 3.65625H7.92857C7.79464 3.65625 7.71429 3.75781 7.71429 3.85938V10.7656C7.71429 10.8926 7.79464 10.9688 7.92857 10.9688ZM3.64286 10.9688H4.07143C4.17857 10.9688 4.28571 10.8926 4.28571 10.7656V3.85938C4.28571 3.75781 4.17857 3.65625 4.07143 3.65625H3.64286C3.50893 3.65625 3.42857 3.75781 3.42857 3.85938V10.7656C3.42857 10.8926 3.50893 10.9688 3.64286 10.9688ZM11.7857 1.625H9L8.08929 0.507812C7.875 0.228516 7.41964 0 7.07143 0H4.92857C4.55357 0 4.09821 0.228516 3.88393 0.507812L3 1.625H0.214286C0.0803571 1.625 0 1.72656 0 1.82812V2.23438C0 2.36133 0.0803571 2.4375 0.214286 2.4375H0.857143V11.7812C0.857143 12.4668 1.41964 13 2.14286 13H9.85714C10.5536 13 11.1429 12.4668 11.1429 11.7812V2.4375H11.7857C11.8929 2.4375 12 2.36133 12 2.23438V1.82812C12 1.72656 11.8929 1.625 11.7857 1.625ZM4.58036 0.990234C4.63393 0.888672 4.79464 0.837891 4.92857 0.8125H7.07143C7.17857 0.837891 7.33929 0.888672 7.39286 0.990234L7.92857 1.625H4.07143L4.58036 0.990234ZM10.2857 11.7812C10.2857 12.0098 10.0714 12.1875 9.85714 12.1875H2.14286C1.90179 12.1875 1.71429 12.0098 1.71429 11.7812V2.4375H10.2857V11.7812ZM5.78571 10.9688H6.21429C6.32143 10.9688 6.42857 10.8926 6.42857 10.7656V3.85938C6.42857 3.75781 6.32143 3.65625 6.21429 3.65625H5.78571C5.65179 3.65625 5.57143 3.75781 5.57143 3.85938V10.7656C5.57143 10.8926 5.65179 10.9688 5.78571 10.9688Z"
                                                fill={this.props.notifications.filter(el => el.isSelected == true).length > 0 ? "#0066B2" : "#b7b7b7"} />
                                        </svg>
                                    </button>
                                    <div style={{ padding: 5, position: 'relative' }}>
                                        <button type="button" className="dashboard-notification-section-header-button m-0" onClick={this.openDateRange} style={{ cursor: 'pointer' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M3 9H21M7 3V5M17 3V5M6 13H8M6 17H8M11 13H13M11 17H13M16 13H18M16 17H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z" stroke="#0066B2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </button>
                                        {dateRangeOpen && (
                                            <div style={{ border: '1px solid #E8ECEF', borderRadius: 12, padding: 16, marginBottom: 16, background: '#fff', position: 'absolute', zIndex: 10, top: '2rem', width: 'max-content' }}>
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                                                    <button type="button" onClick={() => this.setPresetRange('today')} style={{ background: dateRangeFilter === 'today' ? '#0066B2' : '#fff', color: dateRangeFilter === 'today' ? '#fff' : '#2E3131', border: '1px solid #E8ECEF', borderRadius: 24, padding: '8px 14px', cursor: 'pointer' }}>
                                                        {t('today')}
                                                    </button>
                                                    <button type="button" onClick={() => this.setPresetRange('thisWeek')} style={{ background: dateRangeFilter === 'thisWeek' ? '#0066B2' : '#fff', color: dateRangeFilter === 'thisWeek' ? '#fff' : '#2E3131', border: '1px solid #E8ECEF', borderRadius: 24, padding: '8px 14px', cursor: 'pointer' }}>
                                                        {t('this week')}
                                                    </button>
                                                    <button type="button" onClick={() => this.setPresetRange('thisMonth')} style={{ background: dateRangeFilter === 'thisMonth' ? '#0066B2' : '#fff', color: dateRangeFilter === 'thisMonth' ? '#fff' : '#2E3131', border: '1px solid #E8ECEF', borderRadius: 24, padding: '8px 14px', cursor: 'pointer' }}>
                                                        {t('this month')}
                                                    </button>
                                                    {/* <button type="button" onClick={() => this.setState({ dateRangeFilter: 'manual' })} style={{ background: dateRangeFilter === 'manual' ? '#0066B2' : '#fff', color: dateRangeFilter === 'manual' ? '#fff' : '#2E3131', border: '1px solid #E8ECEF', borderRadius: 24, padding: '8px 14px', cursor: 'pointer' }}>
                                                        {t('Manual range')}
                                                    </button> */}
                                                </div>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                                                        <div style={{ minWidth: 100, flex: 1, minHeight: 70 }}>
                                                            <div style={{ color: '#586268', fontSize: 12 }}>{t('From date')}</div>
                                                            <div className="date-picker-wrapper">
                                                                <KeyboardDatePicker
                                                                    format="dd/MM/yyyy"
                                                                    value={beginDate}
                                                                    onChange={(date) => this.updateBeginDate(date)}
                                                                    disableFuture={true}
                                                                    variant="inline"
                                                                    inputVariant="outlined"
                                                                    style={{ width: '100%' }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div style={{ minWidth: 100, flex: 1, minHeight: 70 }}>
                                                            <div style={{ color: '#586268', fontSize: 12 }}>{t('To date')}</div>
                                                            <div className="date-picker-wrapper">
                                                                <KeyboardDatePicker
                                                                    format="dd/MM/yyyy"
                                                                    value={endDate}
                                                                    onChange={(date) => this.updateEndDate(date)}
                                                                    disableFuture={true}
                                                                    variant="inline"
                                                                    inputVariant="outlined"
                                                                    style={{ width: '100%' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </MuiPickersUtilsProvider>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
                                                    {dateRangeFilter !== 'none' && (
                                                        <button type="button" onClick={this.clearDateRange} style={{ background: 'transparent', color: '#0066B2', border: '1px solid #0066B2', borderRadius: 24, padding: '10px 16px', cursor: 'pointer' }}>
                                                            {t('Clear')}
                                                        </button>
                                                    )}
                                                    <button type="button" onClick={this.applyDateRange} disabled={!beginDate || !endDate} style={{ background: '#0066B2', color: '#fff', border: 'none', borderRadius: 24, padding: '10px 16px', cursor: !beginDate || !endDate ? 'not-allowed' : 'pointer', opacity: !beginDate || !endDate ? 0.6 : 1 }}>
                                                        {t('Search')}
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                            <ul className="dashboard-notification-section-list">
                                {
                                    this.props.notifications && this.props.notifications.length > 0 ?
                                        this.props.notifications.map((item, index) => {
                                            return (
                                                <li key={index} className={`dashboard-notification-section-item ${this.props.match.params.id == item.id ? 'dashboard-notification-section-item__selected' : ''}`}>
                                                    <div className="dashboard-notification-section-item-left">
                                                        <CheckboxTick checked={Boolean(item.isSelected)} onChecked={val => this.selectFunc(val, index)} />
                                                    </div>
                                                    <div onClick={() => {
                                                        if (item.notificationTypeId == 2) {
                                                            this.readIdFunc(item.id);
                                                            if (item.notificationType == 'FriendNotificationToFriend') {
                                                                this.props.history.push(`/dashboard/transfer/card-operation/friend-transfer/history/1`);
                                                            }
                                                            else {
                                                                this.props.history.push(`/dashboard/transfer/card-operation/friend-transfer/history/2`);
                                                            }
                                                        } else if (item.notificationType === "DEBT_NOTIFICATION") {
                                                            if (item.isRead === 0) {
                                                                this.readIdFunc(item.id);
                                                            }
                                                            this.props.updateAppState('isLoadingTransparentBackground', true);
                                                            let getPaymentTempRequest = {
                                                                tempId: item?.oprId,
                                                                token: localStorage.getItem('token'),
                                                                lang: localStorage.getItem('i18nextLng').toUpperCase()
                                                            }
                                                            fetch(request("pg/getPaymentTemp", getPaymentTempRequest))
                                                                .then(res => res.json())
                                                                .then((getPaymentTempResponse) => {
                                                                    if (getPaymentTempResponse.status.statusCode !== 1) {
                                                                        if (getPaymentTempResponse.status.statusCode === 200) {
                                                                            this.props.logout();
                                                                        } else {
                                                                            this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getPaymentTempResponse.status.statusCode));
                                                                        }
                                                                    }
                                                                    else {
                                                                        let { merchantId, categoryId, id } = getPaymentTempResponse.template
                                                                        this.props.history.push(`/dashboard/payment/templates/template-pay/${categoryId}/providers/${merchantId}/temp/${id}`);
                                                                    }
                                                                    this.props.updateAppState('isLoadingTransparentBackground', false);
                                                                },
                                                                    (error) => {
                                                                        this.props.history.push("/technical-break");
                                                                    });
                                                        }
                                                        else {
                                                            this.props.history.push(`/dashboard/notifications/${item.id}`);
                                                        }
                                                    }} style={{ cursor: 'pointer', width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} className="dashboard-notification-section-item-right">
                                                        <div style={{ width: '94%' }}>
                                                            <h4 className="dashboard-notification-section-item-title" style={{ fontWeight: item.isRead == 1 ? 'normal' : 'bold', color: item.isRead ? '#849097' : '#2E3131' }}>{item.title}</h4>
                                                            <p className="dashboard-notification-section-item-description" style={{ color: item.isRead ? '#849097' : '#586268' }}>{item.content}</p>
                                                        </div>
                                                        {item.isRead == 0 ? <div style={{ width: '8px', height: '8px', borderRadius: '4px', backgroundColor: '#0066B2', alignContent: 'flex-end' }}></div> : null}
                                                    </div>
                                                </li>
                                            );
                                        }) :
                                        null
                                }
                            </ul>
                        </div>
                        <div className="dashboard-notification-section-right" >
                            {
                                loading ? <Loading /> :
                                    notification ?
                                        <>
                                            {notification?.image &&
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <img style={{ width: 'auto', maxWidth: '100%' }} src={notification?.image} alt="notificationImage" />
                                                </div>}
                                            <h3 className="dashboard-notification-section-title">{notification?.title}</h3>
                                            <p className="dashboard-notification-section-content">
                                                {notification?.content}
                                            </p>
                                            <div className="modal-sms-service-buttons justify-content-start mx-0">
                                                {links && links.length > 0 &&
                                                    <button className="modal-sms-service-button-yes" style={{ width: '150px', borderRadius: '25px' }} onClick={() => links.length == 1 ? window.open(links[0].link) : this.setState({ open: true })}>
                                                        <span>{t('detailed')}</span>
                                                    </button>}
                                                {notification.type &&
                                                    <button className="modal-sms-service-button-yes ml-2" style={{ width: '150px', borderRadius: '25px' }} onClick={() => this.getRedirectLink(notification.type, notification?.oprId)}>
                                                        <span>{t('Order')}</span>
                                                    </button>}
                                                {notification.notificationType === "E_CONTRACT" &&
                                                    <button className="modal-sms-service-button-yes ml-2" style={{ width: '150px', borderRadius: '25px' }} onClick={() => this.getRedirectLink(notification.notificationType, notification?.oprId)}>
                                                        <span>{t('redirect')}</span>
                                                    </button>}
                                            </div>
                                        </>
                                        :
                                        <div className="dashboard-finance-section-invisible-cards-section">
                                            <img style={{ maxWidth: '400px' }} src={iconNotificationNot} className="dashboard-finance-section-invisible-cards-section-image" alt="iconNotificationNot" />
                                        </div>
                            }
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default translate("translation")(Notification);